import { ComplexValue } from 'app/types-shared';
import { ListBranchItem } from '../types-store';

const subscriberGroupSelected =
  (subscriberGroup: ComplexValue<number>) =>
    (item: ListBranchItem) =>
      item?.subscriberGroup?.some(itemSubscriberGroup => itemSubscriberGroup.value === subscriberGroup?.value) ?? false;

const applySubscriberGroupSelection =
  (subscriberGroup: ComplexValue<number>) =>
    (item: ListBranchItem, selected: boolean): ListBranchItem => {

      if (!subscriberGroup?.value || subscriberGroupSelected(subscriberGroup)(item) === selected) {
        return item;
      }

      return {
        ...item,
        subscriberGroup: selected
          ? [...(item.subscriberGroup || []), { value: subscriberGroup.value }]
          : (item.subscriberGroup || []).filter(itemSubscriberGroup => itemSubscriberGroup.value !== subscriberGroup?.value)
      };
    };

export const activeItemSelected = (
  activeItem: ComplexValue<number>
) => subscriberGroupSelected(activeItem);

export const applySelectionOnActiveItem = (
  activeItem: ComplexValue<number>
) => applySubscriberGroupSelection(activeItem);
